<template>
  <section class="progress-holder">
    <div class="upload-holder">
      <h2 class="title">Aan het uploaden...</h2>
      <p class="progress" v-if="progress < 1">1%</p>
      <p class="progress" v-else>{{ progress }}%</p>
    </div>
  </section>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  props: ['progress'],
  data() {
    return {}
  },
  computed: {
    ...mapStores(usePrintStoreStore)
  },
  watch: {
    progress: function (val) {
      if (val === 100) {
        this.$modal.hideAll()
        this.printStoreStore.uploadProgress = 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.progress-holder {
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.upload-holder {
  text-align: center;
}

.title {
  font-weight: 400;
}

.progress {
  color: var(--sub-color);
  font-size: 92px;
  line-height: 86px;
}
</style>
